const TaxFeeCalculatedOn = {
  RoomRateTotal: 'RoomRateTotal',
  RunningTotal: 'RunningTotal'
};

export default TaxFeeCalculatedOn;
